import { render, staticRenderFns } from "./NominaEmpleados.vue?vue&type=template&id=db11ac0c"
import script from "./NominaEmpleados.vue?vue&type=script&lang=js"
export * from "./NominaEmpleados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports